/**
 * trend-breakout-page.js
 *
 * Trend Breakout strategy (breakout + retest) — across Weekly, Daily, 4H:
 *   Long:  50 SMA sloping up · price broke above a prior swing-high close and
 *          is now pulling back onto it (level − 0.5 ATR … level + 1 ATR)
 *   Short: 50 SMA sloping down · price broke below a prior swing-low close and
 *          is now rallying back onto it (level − 1 ATR … level + 0.5 ATR)
 * Detection lives in server/indicator-engine.js + data-service.js.
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchTrendBreakoutData } from '../services/server-api';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function slopeLabel(slope) {
  if (slope === 'up')   return '↑ rising';
  if (slope === 'down') return '↓ falling';
  return '→ flat';
}

function fmt(v) {
  return v != null ? `$${v.toLocaleString(undefined, { maximumFractionDigits: 6 })}` : '—';
}

function renderDetails(entry) {
  const levelLabel = entry.state === 'long' ? 'Broken High' : 'Broken Low';
  const levelVal   = fmt(entry.swingLevel);
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">Valid Zone</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
          {fmt(entry.zoneLow)} – {fmt(entry.zoneHigh)}
        </span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">{levelLabel}</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
          {levelVal}
        </span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">50 SMA</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
          {slopeLabel(entry.sma50Slope)}
        </span>
      </div>
    </>
  );
}

function TrendBreakoutPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'Trend Breakout',
        icon:       '🧭',
        subtitle:   '50 SMA sloping up/down · price retesting a broken swing-close high/low · valid zone sized by ATR(10)',
        fetchFn:    fetchTrendBreakoutData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default TrendBreakoutPage;
